export default __webpack_public_path__ + "static/media/undo.407ad9d8.svg";